import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "drag_vertical",
  "use": "drag_vertical-usage",
  "viewBox": "0 0 4 14.75",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 4 14.75\" id=\"drag_vertical\"><defs></defs><g class=\"cls-1\"><path d=\"M1.33 14.75H0v-1.33h1.33zm2.67 0H2.67v-1.33H4zm0-2.67H2.67v-1.33H4zm-2.67 0H0v-1.33h1.33zM4 9.45H2.67V8.12H4zm-2.67 0H0V8.12h1.33zM1.33 6.67H0V5.33h1.33zm2.67 0H2.67V5.33H4zM1.33 4H0V2.67h1.33zM4 4H2.67V2.67H4zm0-2.67H2.67V0H4zm-2.67 0H0V0h1.33z\" class=\"cls-2\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol